import React, { FC } from "react";
import { Button, Link } from "gatsby-theme-material-ui";
import { KeyboardArrowRightRounded } from "@mui/icons-material";
import { Colors } from "@src/gatsby-theme-material-ui-top-layout/colors";

interface Props {
  url: string;
  variant?: "outlined" | "contained" | "text";
  children: JSX.Element | string | undefined;
  testId?: string;
}

const BaseButton: FC<Props> = ({
  url,
  variant = "outlined",
  testId = "",
  children,
}) => {
  return (
    <Link href={url} underline="none" data-testid={testId}>
      <Button
        variant={variant}
        color="secondary"
        sx={{
          color:
            variant === "contained" ? `${Colors.PrimaryMain} !important` : null,
          fontWeight: 500,
          fontSize: "16px",
          fontFamily: "Inter",
        }}
        disableRipple
        disableElevation
        fullWidth
      >
        {children}
        <KeyboardArrowRightRounded
          sx={{
            marginLeft: 0.5,
            fontSize: "20px",
            color:
              variant === "contained"
                ? `${Colors.PrimaryMain} !important`
                : Colors.PrimaryContrast,
          }}
        />
      </Button>
    </Link>
  );
};

export default BaseButton;
